import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import DetailRepository from "../Repositories/DetailRepository";

class DetailBloc {
  listChannel = new Subject();
  employeeListChannel = new Subject();
  exportExcelChannel = new Subject();
  exportRekapChannel = new Subject();
  workUnitChannel = new Subject();
  repository = new DetailRepository();
  exportNewChannel = new Subject();

  hirarkiChannel = new Subject();
  treeHirarkiChannel = new Subject();
  infoUnorChannel = new Subject();
  infoJabatanChannel = new Subject();
  fetchexportDataNewPetajabatanChannel = new Subject();
  fetchcreateInfoJabatanChannel = new Subject();
  fetchdetailInfoJabatanChannel = new Subject();
  fetchdetailInfoUnorChannel = new Subject();
  fetchcreateInfoUnorChannel = new Subject();
  infoResumeChannel = new Subject();

  constructor() {
    this.listChannel.next({ status: apiResponse.INITIAL });
    this.employeeListChannel.next({ status: apiResponse.INITIAL });
    this.exportRekapChannel.next({ status: apiResponse.INITIAL });
    this.exportExcelChannel.next({ status: apiResponse.INITIAL });
    this.workUnitChannel.next({ status: apiResponse.INITIAL });
    this.exportNewChannel.next({ status: apiResponse.INITIAL });


    this.hirarkiChannel.next({ status: apiResponse.INITIAL });
    this.treeHirarkiChannel.next({ status: apiResponse.INITIAL });
    this.infoUnorChannel.next({ status: apiResponse.INITIAL });
    this.infoJabatanChannel.next({ status: apiResponse.INITIAL });
    this.infoResumeChannel.next({ status: apiResponse.INITIAL });
    this.fetchexportDataNewPetajabatanChannel.next({ status: apiResponse.INITIAL });
    this.fetchcreateInfoJabatanChannel.next({ status: apiResponse.INITIAL });
    this.fetchdetailInfoJabatanChannel.next({ status: apiResponse.INITIAL });
    this.fetchdetailInfoUnorChannel.next({ status: apiResponse.INITIAL });
    this.fetchcreateInfoUnorChannel.next({ status: apiResponse.INITIAL });
  }

  fetchList = async (query) => {
    try {
      this.listChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchList(query)
        .then((result) => {
          this.listChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.listChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchListEmployee = async (query) => {
    try {
      this.employeeListChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchListEmployee(query)
        .then((result) => {
          this.employeeListChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeeListChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchExportExcel = async (query) => {
    try {
      this.exportExcelChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchExportExcel(query)
        .then((result) => {
          this.exportExcelChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.exportExcelChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };
  fetchExportRekap = async (query) => {
    try {
      this.exportRekapChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchExportRekap(query)
        .then((result) => {
          this.exportRekapChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.exportRekapChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchWorkUnit = async (query) => {
    try {
      this.workUnitChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchWorkUnit(query)
        .then((result) => {
          this.workUnitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.workUnitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchExportNew = async (query) => {
    try {
      this.exportNewChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchExportNew(query)
        .then((result) => {
          this.exportNewChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.exportNewChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };



  fetchHirarki = async (query) => {
    try {
        this.hirarkiChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchHirarki(query).then((result) => {
            this.hirarkiChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.hirarkiChannel.next({status: apiResponse.ERROR, data: error })
        })
    } catch (error) {
        console.log('rxjs', 'Channel Unsubscribed') 
    }
  }


  fetchTreeHirarki = async (query) => {
    try {
        this.treeHirarkiChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchTreeHirarki(query).then((result) => {
            this.treeHirarkiChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.treeHirarkiChannel.next({status: apiResponse.ERROR, data: error })
        })
    } catch (error) {
        console.log('rxjs', 'Channel Unsubscribed') 
    }
  }
  
  fetchInfoUnor = async (query) => {
    try {
        this.infoUnorChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchInfoUnor(query).then((result) => {
            this.infoUnorChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.infoUnorChannel.next({status: apiResponse.ERROR, data: error })
        })
    } catch (error) {
        console.log('rxjs', 'Channel Unsubscribed') 
    }
  }
  
  fetchInfoJabatan = async (query) => {
    try {
        this.infoJabatanChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchInfoJabatan(query).then((result) => {
            this.infoJabatanChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.infoJabatanChannel.next({status: apiResponse.ERROR, data: error })
        })
    } catch (error) {
        console.log('rxjs', 'Channel Unsubscribed') 
    }
  }

  fetchInfoResume = async (query) => {
    try {
        this.infoResumeChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchInfoResume(query).then((result) => {
            this.infoResumeChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.infoResumeChannel.next({status: apiResponse.ERROR, data: error })
        })
    } catch (error) {
        console.log('rxjs', 'Channel Unsubscribed') 
    }
  }
  
  fetchexportDataNewPetajabatan = async (query) => {
    try {
      this.fetchexportDataNewPetajabatanChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchexportDataNewPetajabatan(query)
        .then((result) => {
          this.fetchexportDataNewPetajabatanChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.fetchexportDataNewPetajabatanChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchdetailInfoJabatan = async (query) => {
    try {
      this.fetchdetailInfoJabatanChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchdetailInfoJabatan(query)
        .then((result) => {
          this.fetchdetailInfoJabatanChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.fetchdetailInfoJabatanChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

   fetchcreateInfoJabatan = async (query) => {
        try {
            this.fetchcreateInfoJabatanChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchcreateInfoJabatan(query).then((result) => {
                this.fetchcreateInfoJabatanChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.fetchcreateInfoJabatanChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

  fetchdetailInfoUnor = async (query) => {
    try {
      this.fetchdetailInfoUnorChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchdetailInfoUnor(query)
        .then((result) => {
          this.fetchdetailInfoUnorChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.fetchdetailInfoUnorChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel Unsubscribed");
    }
  };

  fetchcreateInfoUnor = async (query) => {
        try {
            this.fetchcreateInfoUnorChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchcreateInfoUnor(query).then((result) => {
                this.fetchcreateInfoUnorChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.fetchcreateInfoUnorChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

}

export default DetailBloc;
